import React from 'react';
import SecuredZone from '../SecuredZone/SecuredZone';
import Dialog from '@material-ui/core/Dialog';
import API from '../../../api/api';
import LinearProgress from '@material-ui/core/LinearProgress';
import { getImageUrl } from '../../../utils/imageUtils';
import { Component } from 'react';
import { 
  Paper, 
  Box, 
  Typography, 
  Grid, 
  Card, 
  CardContent, 
  IconButton,
  Chip,
  Tooltip,
  Divider
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import AdminEmployeesDialog from '../../../dialogs/admin-employees/admin-employees';

const garageApi = new API();

class AdminEmployees extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      adminEmployeesDialog: false,
      employees: [],
      editEmployee: {},
    };
  }

  componentDidMount() {
    this.loadEmployees();
  }

  loadEmployees() {
    garageApi.endpoints.employees.getAll()
      .then((getRequest) => {
        try {
          console.log('Admin Employees API response:', getRequest);
          console.log('Admin Employees data:', getRequest.data);
          
          // Unterstütze sowohl results als auch direkte Arrays
          let employees = [];
          if (getRequest && getRequest.data) {
            if (Array.isArray(getRequest.data)) {
              employees = getRequest.data;
            } else if (getRequest.data.results && Array.isArray(getRequest.data.results)) {
              employees = getRequest.data.results;
            }
          }
          
          console.log('Parsed admin employees:', employees);
          this.setState({ employees: employees, loading: false });
        } catch(e) {
          console.error('Error parsing admin employees:', e);
          this.setState({ employees: [], loading: false });
        }
      })
      .catch((error) => {
        console.error('Error loading admin employees:', error);
        this.setState({ employees: [], loading: false });
      });
  }

  deleteEmployee(unikey) {
    if (!window.confirm('Möchten Sie diesen Mitarbeiter wirklich löschen?')) {
      return;
    }

    var deleteEmployee = this.state.employees.find((element) => { return element.unikey === unikey; });
    if (!deleteEmployee) return;

    this.setState({ loading: true });

    garageApi.endpoints.employees.delete({ id: deleteEmployee.id })
      .then(() => {
        this.loadEmployees();
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  closeAdminEmployeesDialog() {
    this.setState({ adminEmployeesDialog: false });
    this.setState({ editEmployee: {} });
  }

  submitAdminEmployeesDialog(mode, user) {
    this.setState({ loading: true });
    if(mode) {
      garageApi.endpoints.employees.create(user)
        .then(() => {
          this.loadEmployees();
        })
        .catch(() => {
          this.setState({ loading: false });
        });
    } else {
      garageApi.endpoints.employees.update(user)
        .then(() => {
          this.loadEmployees();
        })
        .catch(() => {
          this.setState({ loading: false });
        });
    }
    this.setState({ adminEmployeesDialog: false });
    this.setState({ editEmployee: {} });
  }

  moveEmployee(unikey, direction) {
    const employees = [...this.state.employees].sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
    const index = employees.findIndex((employee) => employee.unikey === unikey);
    const swapIndex = index + direction;
    if (index < 0 || swapIndex < 0 || swapIndex >= employees.length) {
      return;
    }

    const current = employees[index];
    const neighbor = employees[swapIndex];
    const currentOrder = current.sort_order || current.id || index + 1;
    const neighborOrder = neighbor.sort_order || neighbor.id || swapIndex + 1;

    this.setState({ loading: true });

    Promise.all([
      garageApi.endpoints.employees.update({ id: current.id, sort_order: neighborOrder }),
      garageApi.endpoints.employees.update({ id: neighbor.id, sort_order: currentOrder }),
    ])
      .then(() => this.loadEmployees())
      .catch(() => this.setState({ loading: false }));
  }

  editEmployee(unikey) {
    var editEmployee = this.state.employees.find((element) => { return element.unikey === unikey; });
    this.setState({ editEmployee: editEmployee || {} });
    this.setState({ adminEmployeesDialog: true });
  }

  createEmployee() {
    this.setState({ adminEmployeesDialog: true });
  }

  render() {
    const { loading, employees, adminEmployeesDialog, editEmployee } = this.state;

    return (
      <SecuredZone
        breadcrumbs={{ '/admin/': 'Dashboard', '/admin/employees': 'Mitarbeiter' }}
        menu={{ 'Mitarbeiter Hinzufügen': this.createEmployee.bind(this) }}
        title="Mitarbeiter"
        loading={loading ? <LinearProgress color="primary" /> : <span className="loader-span"></span>}
      >
        <Dialog 
          open={adminEmployeesDialog} 
          onClose={this.closeAdminEmployeesDialog.bind(this)}
          maxWidth="md"
          fullWidth
        >
          <AdminEmployeesDialog 
            key={editEmployee.id || 'new'}
            employeesData={editEmployee} 
            close={this.closeAdminEmployeesDialog.bind(this)} 
            submit={this.submitAdminEmployeesDialog.bind(this)}
          />
        </Dialog>
        
        {!loading && (
          <Box style={{ padding: '20px' }}>
            {/* Statistik */}
            <Paper elevation={2} style={{ padding: '20px', marginBottom: '24px', background: 'linear-gradient(135deg, #7b1fa2 0%, #ba68c8 100%)', color: 'white' }}>
              <Box display="flex" alignItems="center" justifyContent="space-between">
                <Box>
                  <Typography variant="h4" style={{ fontWeight: 700, marginBottom: '8px' }}>
                    {employees.length}
                  </Typography>
                  <Typography variant="body1" style={{ opacity: 0.9 }}>
                    {employees.length === 1 ? 'Mitarbeiter' : 'Mitarbeiter'} insgesamt
                  </Typography>
                </Box>
                <PersonOutlineIcon style={{ fontSize: 60, opacity: 0.3 }} />
              </Box>
            </Paper>

            {/* Employees Grid */}
            {employees.length > 0 ? (
              <Grid container spacing={3}>
                {employees.map((employee, index) => (
                  <Grid item xs={12} sm={6} md={4} key={employee.unikey}>
                    <Card 
                      style={{ 
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        transition: 'transform 0.2s, box-shadow 0.2s',
                        position: 'relative',
                        backgroundImage: employee.image 
                          ? `url(${getImageUrl(employee.image, 'large') || ''})`
                          : 'none',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundColor: (employee.image && getImageUrl(employee.image, 'large')) ? 'transparent' : '#f5f5f5',
                        minHeight: '350px',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-4px)';
                        e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                      }}
                    >
                      {/* Overlay für bessere Lesbarkeit */}
                      {employee.image && getImageUrl(employee.image, 'large') && (
                        <Box
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: 'linear-gradient(to bottom, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.8) 100%)',
                            zIndex: 1,
                          }}
                        />
                      )}
                      <CardContent style={{ 
                        flexGrow: 1, 
                        display: 'flex', 
                        flexDirection: 'column',
                        position: 'relative',
                        zIndex: 2,
                        color: (employee.image && getImageUrl(employee.image, 'large')) ? 'white' : 'inherit',
                      }}>
                        <Typography variant="h6" component="h2" style={{ fontWeight: 600, marginBottom: '4px' }}>
                          {employee.name || 'Unbekannt'}
                        </Typography>
                        {employee.position && (
                          <Chip 
                            label={employee.position} 
                            size="small" 
                            style={{ 
                              marginBottom: '8px', 
                              width: 'fit-content',
                              backgroundColor: (employee.image && getImageUrl(employee.image, 'large')) ? 'rgba(255,255,255,0.2)' : undefined,
                              color: (employee.image && getImageUrl(employee.image, 'large')) ? 'white' : undefined,
                            }}
                            color={(employee.image && getImageUrl(employee.image, 'large')) ? 'default' : 'primary'}
                          />
                        )}
                        {employee.job && (
                          <Typography 
                            variant="body2" 
                            style={{ 
                              marginBottom: '12px',
                              color: (employee.image && getImageUrl(employee.image, 'large')) ? 'rgba(255,255,255,0.9)' : undefined,
                            }}
                            color={(employee.image && getImageUrl(employee.image, 'large')) ? undefined : 'textSecondary'}
                          >
                            {employee.job}
                          </Typography>
                        )}
                        <Divider style={{ margin: '12px 0', backgroundColor: (employee.image && getImageUrl(employee.image, 'large')) ? 'rgba(255,255,255,0.3)' : undefined }} />
                        <Box style={{ flexGrow: 1 }}>
                          {employee.email && (
                            <Box display="flex" alignItems="center" style={{ marginBottom: '8px' }}>
                              <EmailIcon style={{ fontSize: 16, marginRight: '8px', color: (employee.image && getImageUrl(employee.image, 'large')) ? 'rgba(255,255,255,0.9)' : '#666' }} />
                              <Typography 
                                variant="body2" 
                                style={{ color: (employee.image && getImageUrl(employee.image, 'large')) ? 'rgba(255,255,255,0.9)' : undefined }}
                                color={(employee.image && getImageUrl(employee.image, 'large')) ? undefined : 'textSecondary'}
                              >
                                {employee.email}
                              </Typography>
                            </Box>
                          )}
                          {employee.phone && (
                            <Box display="flex" alignItems="center">
                              <PhoneIcon style={{ fontSize: 16, marginRight: '8px', color: (employee.image && getImageUrl(employee.image, 'large')) ? 'rgba(255,255,255,0.9)' : '#666' }} />
                              <Typography 
                                variant="body2" 
                                style={{ color: (employee.image && getImageUrl(employee.image, 'large')) ? 'rgba(255,255,255,0.9)' : undefined }}
                                color={(employee.image && getImageUrl(employee.image, 'large')) ? undefined : 'textSecondary'}
                              >
                                {employee.phone}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                        <Box display="flex" alignItems="center" justifyContent="flex-end" marginTop="auto" paddingTop="12px">
                          <Tooltip title="Nach oben">
                            <span>
                              <IconButton 
                                size="small" 
                                disabled={index === 0}
                                onClick={() => { this.moveEmployee(employee.unikey, -1); }}
                                style={{ color: '#1976d2' }}
                              >
                                <ArrowUpwardIcon fontSize="small" />
                              </IconButton>
                            </span>
                          </Tooltip>
                          <Tooltip title="Nach unten">
                            <span>
                              <IconButton 
                                size="small" 
                                disabled={index === employees.length - 1}
                                onClick={() => { this.moveEmployee(employee.unikey, 1); }}
                                style={{ color: '#1976d2' }}
                              >
                                <ArrowDownwardIcon fontSize="small" />
                              </IconButton>
                            </span>
                          </Tooltip>
                          <Tooltip title="Bearbeiten">
                            <IconButton 
                              size="small" 
                              onClick={() => { this.editEmployee(employee.unikey); }}
                              style={{ color: '#1976d2' }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Löschen">
                            <IconButton 
                              size="small" 
                              onClick={() => { this.deleteEmployee(employee.unikey); }}
                              style={{ color: '#d32f2f' }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Paper elevation={2} style={{ padding: '60px', textAlign: 'center' }}>
                <PersonOutlineIcon style={{ fontSize: 80, color: '#ccc', marginBottom: '20px' }} />
                <Typography variant="h6" color="textSecondary" style={{ marginBottom: '8px' }}>
                  Noch keine Mitarbeiter vorhanden
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Klicken Sie auf "Mitarbeiter Hinzufügen" um Ihren ersten Mitarbeiter zu erstellen.
                </Typography>
              </Paper>
            )}
          </Box>
        )}
      </SecuredZone>
    );
  }
}

export default AdminEmployees;
